<template>
    <v-container fluid grid-list-md text-xs-center>
        <v-flex xs12>
            <v-img :src="require('../assets/van.png')"></v-img>
        </v-flex>

        <v-layout justify-center>
            <v-flex x12>
                <h1>Contactez-nous!</h1>
                <v-divider inset></v-divider>
            </v-flex>
        </v-layout>

        <v-layout row wrap>
            <v-flex xs12>
                <v-container
                        grid-list-md
                        text-xs-center
                >
                    <v-layout row wrap justify-center>
                        <v-flex>
                            <v-card>
                                <v-card-title>
                                    <h1>Appelez-nous</h1>
                                </v-card-title>
                                <v-card-text>
                                    <v-icon class="blue--text darken-3">fas fa-phone</v-icon>
                                    <h2><a href="tel://1-418-688-3311" class="decoration">(418) 688-3311</a></h2>
                                    </br>
                                    <p>
                                        Lun-Mer : 9h à 17h30</br>
                                        Jeu-Ven : 9h à 21h</br>
                                        Sam : 9h à 17h</br>
                                        Dim : 10h à 17h
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex>
                            <v-card>
                                <v-card-title>
                                    <h1>Écrivez-nous</h1>
                                </v-card-title>
                                <v-card-text>
                                    <v-icon class="blue--text darken-3">fas fa-envelope</v-icon>
                                    <h3><a href="mailto: info@veloshop.ca" class="decoration">info@veloshop.ca</a></h3>
                                    <!--<v-form>
                                        <v-text-field
                                            v-model="name"
                                            label="Name"
                                            required
                                            outline></v-text-field>

                                        <v-text-field
                                            v-model="email"
                                            label="Email"
                                            required
                                            outline></v-text-field>

                                        <v-text-field
                                            v-model="subject"
                                            label="Subject"
                                            outline></v-text-field>

                                        <v-textarea
                                            v-model="message"
                                            label="Message"
                                            required
                                            outline
                                            ></v-textarea>
                                    </v-form>
                                    <v-btn color="info">Envoyer</v-btn>-->
                                </v-card-text>
                            </v-card>
                        </v-flex>

                        <v-flex>
                            <v-card>
                                <v-card-title><h1>Heures de service</h1></v-card-title>
                                <v-card-text>
                                    <v-label>
                                        Du lundi au dimanche</br>
                                        de 8h00 à 20h00
                                    </v-label>
                                </v-card-text>
                                <v-card-actions>
                                    <v-list-tile class="grow">
                                        <v-icon class="white--text">fas fa-arrow-right</v-icon>
                                    </v-list-tile>
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-container>
            </v-flex>
        </v-layout>


        <!--footer-->
        <v-layout justify-center>
            <v-flex xs12>
                <v-footer
                        dark
                        height="auto">
                    <v-card
                            class="flex"
                            flat
                            tile>
                        <v-card-title class="teal">
                            <h2>SUIVEZ-NOUS!</h2>
                            <v-divider light></v-divider>
                            <v-btn fab light href="https://www.facebook.com/veloshop.ca/" target="_blank">
                                <v-icon size="24px">fab fa-facebook</v-icon>
                            </v-btn>
                            <v-btn fab light href="https://www.instagram.com/veloshop.ca/?hl=en" target="_blank">
                                <v-icon size="24px">fab fa-instagram</v-icon>
                            </v-btn>
                        </v-card-title>

                        <v-card-actions class="grey darken-3 justify-center">
                            &copy;2019 — <strong>Véloshop.ca</strong>
                        </v-card-actions>

                    </v-card>
                </v-footer>
            </v-flex>
        </v-layout>

    </v-container>
</template>

<script>
    export default {
        name: 'Contact',
        data: () => ({

        })
    }



</script>

<style scoped>
    .decoration {
        text-decoration: none;
    }
</style>
